export const companySettingsMapper = (setting: string) => {
  switch (setting) {
    case 'taskAutoLockWindowCat':
      return 'Lock CAT tasks at (in hours)';
    case 'taskAutoLockWindowNonCat':
      return 'Lock non-CAT tasks at (in hours)';
    default:
      return setting;
  }
};
